import React from 'react';
import {Avatar, Sheet, Stack, Typography} from '@mui/joy';
import {SchoolOutlined} from "@mui/icons-material";
import {SkillModel} from "../model/skill";
import {EducationModel} from "../model/education";
function Education({education}: { education:EducationModel }) {
    const startDate = education.startDate.substring(education.startDate.indexOf('-') + 1).replaceAll('-','/');
    const endDate = (education.endDate.indexOf('-') >= 0)
        ? education.endDate.substring(education.endDate.indexOf('-') + 1).replaceAll('-','/')
        : education.endDate;
    return (
        <Sheet variant='soft' sx={{ padding: 0}}>
            <Stack direction='row' spacing={2} alignItems='start'>
                <Avatar size='sm' variant='solid' color='primary'>
                    <SchoolOutlined/>
                </Avatar>
                <Stack alignContent="center" spacing={0} justifyContent="center" direction="column">
                    <Typography level="body-md">{startDate} - {endDate}</Typography>
                    <Typography level="title-md" fontWeight="lg">{education.title},</Typography>
                    <Typography level="body-md">{education.school}</Typography>
                    <Typography level="body-md">{education.address}</Typography>
                </Stack>
            </Stack>
        </Sheet>
    );
}

export default Education;